/* Accessibility helpers added during the 2026 theme audit (A20/A21).
   Keeps the theme's existing jQuery handlers untouched and only adds keyboard support on top. */
(function () {
  'use strict';
  function $(sel, root) { return (root || document).querySelector(sel); }

  function syncMenuState() {
    var toggle = $('.js-mobile-nav-toggle');
    var nav = $('.mobile-nav-wrapper');
    if (!toggle || !nav) return;
    toggle.setAttribute('aria-expanded', nav.classList.contains('active') ? 'true' : 'false');
  }

  // Keep the skip link the first thing in <body>: third-party widgets (accessibility overlay, cookie
  // banner) prepend themselves to <body> after load, which would push the skip link down the Tab order.
  function keepSkipLinkFirst() {
    var skip = $('body > a.skip-link');
    if (!skip || !window.MutationObserver) return;
    var moves = 0;
    var place = function () {
      if (document.body.firstElementChild !== skip && moves < 10) { moves++; document.body.insertBefore(skip, document.body.firstChild); }
    };
    place();
    new MutationObserver(place).observe(document.body, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var nav = $('.mobile-nav-wrapper');
    keepSkipLinkFirst();
    syncMenuState();
    if (nav && window.MutationObserver) {
      new MutationObserver(syncMenuState).observe(nav, { attributes: true, attributeFilter: ['class'] });
    }

    // Enter / Space activate the non-button controls that only had click handlers.
    document.addEventListener('keydown', function (event) {
      var target = event.target;
      if ((event.key === 'Enter' || event.key === ' ') && target && target.matches && target.matches('.closemobileMenu, .close-announcement')) {
        event.preventDefault();
        target.click();
        return;
      }
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var search = document.getElementById('searchPopup');
      if (search && search.classList.contains('active')) {
        var closeSearch = $('.closeSearch', search);
        if (closeSearch) closeSearch.click();
        var searchIcon = $('.site-header .searchIco');
        if (searchIcon) searchIcon.focus();
        return;
      }
      if (nav && nav.classList.contains('active')) {
        var toggle = $('.js-mobile-nav-toggle');
        if (toggle) { toggle.click(); toggle.focus(); }
      }
    });

    // Mobile submenu toggles (<button class="mobile-nav__toggle">). theme.min.js binds slideToggle to the
    // icon inside the button, so a click on the button itself (keyboard Enter/Space, or a tap beside the
    // icon) is forwarded to the icon; taps on the icon already reach that handler by bubbling.
    document.addEventListener('click', function (event) {
      var btn = event.target && event.target.closest ? event.target.closest('.mobile-nav__toggle') : null;
      if (!btn || event.target !== btn) return;
      var icon = btn.querySelector('.ad');
      if (icon) icon.click();
    });
    // aria-expanded (and the USPA-149 caret rotation) follow the submenu's actual visibility, whoever toggled it.
    Array.prototype.forEach.call(document.querySelectorAll('.mobile-nav__toggle'), function (btn) {
      var sub = btn.nextElementSibling;
      if (!sub || sub.tagName !== 'UL') return;
      var sync = function () {
        var open = getComputedStyle(sub).display !== 'none';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var caret = btn.querySelector('.tin-carot');
        if (caret) caret.classList.toggle('tin-carot-rotate', open);
      };
      if (window.MutationObserver) new MutationObserver(sync).observe(sub, { attributes: true, attributeFilter: ['style'] });
    });

    // The ticker's own "X" button had no handler; route it to the theme's close-announcement logic.
    var exit = $('.notification-bar__exit');
    var close = $('.close-announcement');
    if (exit && close) exit.addEventListener('click', function (event) { event.preventDefault(); close.click(); });
  });
})();
